var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_24055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.6,
    r: 87.5,
    fill: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2379 155.69L54.9587 170.03L178.259 132.529L178.608 126.716L142.171 119.946L20.5882 149.864L20.2379 155.69Z",
    fill: "#6E45EA",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.958 170.029L20.2372 155.69L20.5875 149.863L56.7048 140.976L54.958 170.029Z",
    fill: "#6137DE",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5855 149.877L55.3064 164.217L178.607 126.716L142.518 114.133L20.5855 149.877Z",
    fill: "#875FFE",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.417 65.9028L139.309 72.6157L135.746 131.867L159.855 125.154L163.417 65.9028Z",
    fill: "url(#paint0_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.881 66.6571L139.309 72.6157L135.746 131.867L121.319 125.909L124.881 66.6571Z",
    fill: "url(#paint1_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.308 72.6159L124.88 66.6573L148.293 60.2903L163.42 65.9019L139.308 72.6159Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.214 100.125L110.105 106.838L108.085 140.448L132.194 133.735L134.214 100.125Z",
    fill: "url(#paint2_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6777 100.879L110.105 106.838L108.085 140.448L93.657 134.489L95.6777 100.879Z",
    fill: "url(#paint3_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.107 106.838L95.679 100.879L119.091 94.512L134.219 100.124L110.107 106.838Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.863 86.9837L83.7539 93.6965L80.4272 149.028L104.536 142.315L107.863 86.9837Z",
    fill: "url(#paint4_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3262 87.7379L83.7539 93.6965L80.4272 149.028L65.9995 143.069L69.3262 87.7379Z",
    fill: "url(#paint5_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7532 93.697L69.3254 87.7383L92.7379 81.3714L107.865 86.9829L83.7532 93.697Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5073 73.8418L57.3984 80.5547L52.7658 157.607L76.8747 150.894L81.5073 73.8418Z",
    fill: "url(#paint6_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9707 74.596L57.3984 80.5547L52.7658 157.607L38.3381 151.649L42.9707 74.596Z",
    fill: "url(#paint7_linear_186_24055)",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3977 80.5551L42.97 74.5965L66.3824 68.2295L81.5098 73.8411L57.3977 80.5551Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.655 72.3189C146.075 84.3345 162.64 87.2501 174.656 78.8311C186.671 70.4121 189.587 53.8465 181.168 41.8309C172.749 29.8153 156.183 26.8997 144.168 35.3187C132.152 43.7378 129.236 60.3033 137.655 72.3189ZM142.184 69.1454C148.851 78.6597 161.968 80.9684 171.482 74.3019C180.997 67.6355 183.305 54.5184 176.639 45.0041C169.972 35.4897 156.855 33.1811 147.341 39.8475C137.827 46.514 135.518 59.6311 142.184 69.1454Z",
    fill: "#8963FE",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.879,
    y: 74.2734,
    width: 18.2235,
    height: 6.12413,
    transform: "rotate(54.982 173.879 74.2734)",
    fill: "#BDB0FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.607,
    y: 82.906,
    width: 29.0995,
    height: 8.87421,
    rx: 4.35702,
    transform: "rotate(54.982 181.607 82.906)",
    fill: "#B936D3",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.874 86.5559C175.845 88.0396 175.79 90.067 176.887 91.6323L188.493 108.196C189.899 110.203 192.666 110.69 194.673 109.284C196.104 108.281 196.762 106.587 196.512 104.969C196.222 105.388 195.853 105.764 195.412 106.073C193.405 107.479 190.638 106.992 189.232 104.985L177.626 88.4214C177.222 87.8454 176.975 87.2069 176.874 86.5559Z",
    fill: "#A924C3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.607,
    y: 82.906,
    width: 29.0995,
    height: 8.87421,
    rx: 4.35702,
    transform: "rotate(54.982 181.607 82.906)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.742,
    cy: 54.7437,
    r: 21.0351,
    transform: "rotate(54.982 161.742 54.7437)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.367 60.0306C164.482 60.5419 163.35 60.2391 162.839 59.3542C162.366 58.536 162.09 57.7706 162.012 57.0579C161.943 56.3094 161.977 55.6076 162.114 54.9526C162.26 54.2616 162.462 53.6144 162.72 53.0108C162.964 52.3845 163.181 51.7893 163.371 51.2251C163.57 50.6251 163.669 50.0369 163.67 49.4606C163.693 48.8712 163.547 48.3038 163.232 47.7583C163.087 47.5083 162.889 47.2439 162.637 46.9652C162.385 46.6864 162.06 46.4649 161.662 46.3008C161.274 46.1008 160.811 46.0347 160.274 46.1024C159.724 46.1474 159.097 46.3734 158.392 46.7806C157.619 47.2271 157.06 47.7019 156.714 48.2049C156.391 48.6949 156.209 49.1939 156.17 49.702C156.139 50.1742 156.19 50.6298 156.323 51.0687C156.762 52.2757 156.515 53.6405 155.403 54.2831L155.082 54.4689C153.792 55.2141 152.103 54.7927 151.441 53.4585C151.199 52.9718 151.006 52.5241 150.941 52.2228C150.784 51.3738 150.769 50.5339 150.895 49.7031C151.031 48.8364 151.333 47.9949 151.801 47.1787C152.256 46.3397 152.872 45.544 153.65 44.7914C154.428 44.0388 155.374 43.3407 156.487 42.6972C157.442 42.1456 158.381 41.7243 159.304 41.4334C160.237 41.1065 161.126 40.9411 161.973 40.937C162.829 40.897 163.629 40.9957 164.372 41.233C165.116 41.4704 165.803 41.8464 166.434 42.361C167.065 42.8756 167.61 43.5307 168.07 44.3261C168.647 45.3261 168.992 46.2637 169.104 47.139C169.202 47.9916 169.164 48.8171 168.989 49.6156C168.823 50.3783 168.591 51.1038 168.291 51.7922C167.992 52.4807 167.715 53.156 167.461 53.8181C167.217 54.4444 167.071 55.0588 167.026 55.6614C167.015 55.7963 167.044 55.9811 167.098 56.1936C167.437 57.5209 167.098 59.0299 165.912 59.7154L165.367 60.0306ZM169.897 66.6896C168.579 67.4512 166.893 67.0002 166.131 65.6822C165.37 64.3643 165.821 62.6785 167.139 61.9169L167.207 61.8775C168.525 61.1159 170.211 61.5669 170.972 62.8849C171.734 64.2028 171.283 65.8886 169.965 66.6502L169.897 66.6896Z",
    fill: "#F56087",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.986 69.9876C148.405 82.0032 164.97 84.9188 176.986 76.4998C189.001 68.0808 191.917 51.5152 183.498 39.4996C175.079 27.484 158.513 24.5684 146.498 32.9874C134.482 41.4065 131.567 57.972 139.986 69.9876ZM144.514 66.8141C151.181 76.3284 164.298 78.6371 173.812 71.9706C183.327 65.3042 185.635 52.1871 178.969 42.6728C172.302 33.1584 159.185 30.8498 149.671 37.5162C140.157 44.1827 137.848 57.2998 144.514 66.8141Z",
    fill: "#BDB0FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8842,
    cy: 24.348,
    rx: 22.8842,
    ry: 24.348,
    transform: "matrix(-0.965896 0.258929 0.258929 0.965896 49.0938 79.9121)",
    fill: "#DC466D",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8842,
    cy: 24.348,
    rx: 22.8842,
    ry: 24.348,
    transform: "matrix(-0.965896 0.258929 0.258929 0.965896 52.957 78.4634)",
    fill: "#F56087",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5241 120.465C35.7786 121.737 30.8528 119.075 28.8682 114.414C28.5285 113.616 29.0359 112.748 29.8736 112.523L45.7743 108.261C46.6119 108.036 47.4854 108.534 47.5904 109.395C48.2038 114.424 45.2696 119.193 40.5241 120.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.21345,
    cy: 3.419,
    rx: 3.21345,
    ry: 3.419,
    transform: "matrix(-0.965896 0.258929 0.258929 0.965896 45.502 95.1201)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.21345,
    cy: 3.419,
    rx: 3.21345,
    ry: 3.419,
    transform: "matrix(-0.965896 0.258929 0.258929 0.965896 29.7441 99.344)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.112,
    cy: 79.2602,
    r: 2.12372,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.864,
    cy: 145.026,
    r: 2.12372,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.934,
    cy: 48.6664,
    r: 2.12372,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.0259,
    cy: 68.2361,
    r: 3.87358,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.237,
    cy: 36.2979,
    r: 3.87358,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.024,
    cy: 153.734,
    r: 3.87358,
    fill: "#611FE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_24055",
    x1: 156.017,
    y1: 40.6425,
    x2: 178.131,
    y2: 120.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DACDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_186_24055",
    x1: 133.765,
    y1: 41.8502,
    x2: 102.294,
    y2: 118.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A3DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_186_24055",
    x1: 128.355,
    y1: 49.2233,
    x2: 150.47,
    y2: 128.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DACDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_186_24055",
    x1: 106.104,
    y1: 50.4311,
    x2: 74.6327,
    y2: 126.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A3DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_186_24055",
    x1: 100.698,
    y1: 57.8033,
    x2: 122.812,
    y2: 137.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DACDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_186_24055",
    x1: 78.4463,
    y1: 59.0111,
    x2: 46.9752,
    y2: 135.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A3DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_186_24055",
    x1: 73.0365,
    y1: 66.3826,
    x2: 95.151,
    y2: 145.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DACDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_186_24055",
    x1: 50.7849,
    y1: 67.5903,
    x2: 19.3138,
    y2: 143.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A3DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_24055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0 0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthEmpty);
export default __webpack_public_path__ + "static/media/growth-empty.c30112eb6907310371983eb2b5833b7a.svg";
export { ForwardRef as ReactComponent };